import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
//import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { Constant } from 'src/app/shared/constant';
import { Gtp } from 'src/app/shared/gtp';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {

  model: any = {};
  loading = false;
  error = '';
  form: FormGroup;
  errorForm = false;
  hidePassword = true; // Para controlar la visibilidad de la contraseña

  constructor(
    public constant: Constant,
    public gtp: Gtp,
    public dialog: MatDialog,
    public router: Router,
    private authenticationService: AuthenticationService,
    public formBuilder: FormBuilder,
  ){
    //this.gtp.cerrarVentanas(true);
    //this.authenticationService.setloginStatus(false);

  }

  ngOnInit() {
    //this.authenticationService.logout();
    // window.location.reload();
    this.form = this.formBuilder.group({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
    });
  }

  /**
   * Ejecuta / Verifica el Login de los datos ingresados
   */
  doLogin(){
    this.loading = true;
    this.model = {
      username: this.form.get('username').value,
      password: this.form.get('password').value
    };
    if (this.form.invalid) {
      this.errorValidate();
      return;
    }

    environment.baseUrl = `${environment.host}${environment.path}/${environment.version}`;
    environment.baseUrlV2 = `${environment.host}${environment.path}/${environment.version2}`;

    this.authenticationService.login(this.model).subscribe(data => {
            this.loading = false;
            this.router.navigate(['/']);
            return data;
        },error => {
            // console.log(error)
            this.loading = false;
            const msg = typeof error === 'string' ? error : (error?.message || 'Error desconocido. Verifique su conexión.');
            Swal.fire({
              title: 'Info!',
              text: msg,
              icon: 'warning',
              confirmButtonText: 'Entiendo'
            })
        }
    );
  }

  /**
   * Llamado al Pop up de Olvidé la contraseña
   */
  olidePass() {
    this.dialog.open(LoginDialogOlvidePass, {
      width: '360px',
    });
  }

  /**
   * Llamado al Pop up de Error de los datos
   */
  errorPass() {
    this.dialog.open(LoginDialogErrorPass, {
      width: '360px',
      panelClass: 'loginError'
    });
  }

  /**
   * Llamado al Pop up de error en la validación
   */
  errorValidate() {
    this.dialog.open(LoginDialogValidate, {
      width: '360px',
      panelClass: 'loginError'
    });
  }

}

/**
 * Pop Up Olvidé mi contraseña
 */
@Component({
  selector: 'dialog-olvidepass',
  templateUrl: './login-dialog-olvidepass.html',
})
export class LoginDialogOlvidePass {
  constructor() {}
}

/**
 * Pop Up Error de contraseña
 */
@Component({
  selector: 'dialog-errorpass',
  templateUrl: './login-dialog-errorpass.html',
})
export class LoginDialogErrorPass {
  constructor() {}
}

/**
 * Pop Up Error de validación
 */
@Component({
  selector: 'dialog-validacion',
  templateUrl: './login-dialog-validacion.html',
})
export class LoginDialogValidate {
  constructor() {}
}
